import SaleCreateInvoiceButton from './SaleCreateInvoiceButton';

export default SaleCreateInvoiceButton;